import classnames from 'clsx';
import type { KeyboardEvent } from 'react';
import React, { useState } from 'react';

import StarsButton from '@swf/components/StarsButton/StarsButton';

import ReplyDisabled from '../assets/reply-disabled.svg';
import ReplyEnabled from '../assets/reply-enabled.svg';
import styles from '../shared.scss';

interface Props {
  loading: boolean;
  placeholder: string;
  handleSubmit: (post: string) => void;
  containerClassName: string;
  replyFieldClassName?: string;
  textClassName: string;
  buttonClassName: string;
  useSeparator?: boolean;
}

const Reply: React.FC<Props> = (props) => {
  const [replyMessage, setReplyMessage] = useState('');
  const {
    placeholder,
    handleSubmit,
    loading,
    containerClassName,
    textClassName,
    buttonClassName,
    replyFieldClassName,
    useSeparator = false
  } = props;

  const handleWallMessage = () => {
    try {
      handleSubmit(replyMessage);
    } finally {
      setReplyMessage('');
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (replyMessage) handleWallMessage();
    }
  };

  const replyDisabled = replyMessage.length === 0 || replyMessage.length > 512;

  return (
    <div className={containerClassName}>
      {useSeparator && <div className={styles.separator} />}
      <div
        className={classnames(styles.replyField, {
          [`${replyFieldClassName}`]: !!replyFieldClassName
        })}
      >
        <textarea
          className={textClassName}
          placeholder={placeholder}
          value={replyMessage}
          onChange={(event) => setReplyMessage(event.target.value)}
          onKeyDown={handleKeyDown}
        />
        <StarsButton
          className={buttonClassName}
          icon={replyDisabled ? <ReplyDisabled /> : <ReplyEnabled />}
          onClick={handleWallMessage}
          variant="text"
          block
          disabled={replyDisabled || loading}
          type="submit"
        />
      </div>
    </div>
  );
};

export default Reply;
